// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__14gOz","errorLogs":"EditorFooter_errorLogs__d503r"};